import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { request } from './assets/common_js_files/request';
import Api from './api/api'

// import * as ECharts from 'echarts';

// 移动端使用
// import { LoadMore } from 'mint-ui';
// import 'mint-ui/lib/style.css'
// Vue.component(LoadMore.name, LoadMore);

import Fragment from 'vue-fragment'

Vue.config.productionTip = false

Vue.prototype.$Api = Api
Vue.prototype.$axios = axios
Vue.prototype.$Request = request

Vue.prototype.$message2 = (message,type='success',duration=3000) => {
  console.log(type,'==============>>>>>>>>>>>>>>>>>>type');
  ElementUI.Message({
    message,
    type,
    duration
  })
}


Vue.prototype.$setErrorTips = err => {
  switch(err.message){
    case 'timeout of 5000ms exceeded':
      ElementUI.Message({
        message: '请求超时！',
        type: 'error'
      })
      break;
    default:
      ElementUI.Message({
        message: '请求异常！',
        type: 'error'
      })
  }

  console.warn("RequestErrorInfo:>>>>",{
    err,
    name: err.name,
    message: err.message
  });
},
// Vue.prototype.$ECharts = ECharts

Vue.prototype.$bus = new Vue({})

Vue.use(ElementUI)
Vue.use(Fragment.Plugin);

// 定义全局指令
Vue.directive('resize', {
  // 指令的名称
  // el为绑定的元素，binding为绑定给指令的对象
  bind(el, binding) { 
    let width = '',
      height = '';
    function resize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) binding.value(); 
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(resize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')